import { CardDetails } from "@/components/Cards/View/Details"
import { CardTransactions } from "@/components/Cards/View/Transactions"
import { useCardView } from "@usher/pe-client-front-end-lib"
import { Route, Switch, useParams, useRouteMatch } from "react-router-dom"

export const CardsView = () => {
  const { id } = useParams<{ id: string }>()
  const { path } = useRouteMatch()
  const { card } = useCardView(id)

  if (id !== card.id) return <div className="lds-dual-ring" />
  return (
    <Switch>
      <Route path={path} exact>
        <CardDetails />
      </Route>
      {path}
      <Route path={`${path}/transactions`}>
        <CardTransactions />
      </Route>
    </Switch>
  )
}
